export enum AssistantModel {
  SONNET = "claude-sonnet-5",
  OPUS = "claude-opus-4-8",
  HAIKU = "claude-haiku-4-5",
}

export enum AssistantTone {
  AUTO = "auto",
  PLAIN_ENGLISH = "plain_english",
  STRICT_DATA = "strict_data",
}

export enum AssistantExportFormat {
  XLSX = "xlsx",
  CSV = "csv",
  PDF = "pdf",
}

export interface AssistantExportRequest {
  sql: string;
  format: AssistantExportFormat;
  filename?: string;
  title?: string;
}

export interface AssistantExportResponse {
  filename: string;
  mimeType: string;
  base64: string;
}

/** A conversation turn as sent to / received from the backend. */
export interface AssistantApiMessage {
  role: "user" | "assistant";
  content: string;
}

export interface AssistantConfig {
  enabled: boolean;
  dailyLimit: number;
  usedToday: number;
  remaining: number;
}

export interface AssistantChatResponse {
  reply: string;
}

export interface AssistantModelPricing {
  model: AssistantModel;
  label: string;
  description: string;
  inputPerMTok: number;
  outputPerMTok: number;
  cacheReadPerMTok: number;
  cacheWritePerMTok: number;
}

export interface AssistantModelsResponse {
  models: AssistantModelPricing[];
  defaultModel: AssistantModel;
}

export interface AssistantUsageRow {
  id: number;
  name: string;
  email: string;
  enabled: boolean;
  dailyMessageLimit: number;
  messageCount: number;
  totalTokens: number;
  costUsd: number;
}

export interface ClientAssistantOverview {
  setting: {
    enabled: boolean;
    model: AssistantModel | null;
    effectiveModel: AssistantModel;
  };
  totals: {
    messageCount: number;
    totalTokens: number;
    costUsd: number;
  };
  users: AssistantUsageRow[];
}

export interface UpdateClientAssistantPayload {
  enabled?: boolean;
  model?: AssistantModel | null;
}

export interface UpdateUserAssistantPayload {
  enabled?: boolean;
  dailyMessageLimit?: number;
}
